import React from 'react';
import { useTranslation } from 'react-i18next';

import { CertificationGroup } from '../utils/certificationValidation';
import { ReactComponent as WarningIcon } from 'assets/icons/Warning.svg';
import { useStylesCertificationWarningBanner } from '../styles';

interface ICertificationWarningBannerProps {
  requiredGroups: CertificationGroup[];
  onViewMore: () => void;
}

const CertificationWarningBanner = ({ requiredGroups, onViewMore }: ICertificationWarningBannerProps) => {
  const classes = useStylesCertificationWarningBanner();
  const { t } = useTranslation();

  if (requiredGroups.length === 0) {
    return null;
  }

  return (
    <div className={classes.bannerWrapper}>
      <div className={classes.banner}>
        <WarningIcon className={classes.warningIcon} />
        <span className={classes.bannerText}>{t('certifications.warning.clickViewMore')}</span>
        <span className={classes.viewMoreLink} onClick={onViewMore}>
          {t('certifications.warning.viewMore')}
        </span>
      </div>
    </div>
  );
};

export default React.memo(CertificationWarningBanner);
